import { useState } from "react";
import "./App.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./Components/PrivateRoute/PrivateRoute";

import HomePage from "./Components/HomePage/HomePage";
import EditingPage from "./Components/EditingPage/EditingPage";
import Profile from "./Components/Profile/Profile";
import SignUp from "./Components/SignUp/SignUp";
import Login from "./Components/Login/Login";
import ForgotPassword from "./Components/ForgotPassword/ForgotPassword";
import UpdateProfile from "./Components/UpdateProfile/UpdateProfile";
import AllDesigns from "./Components/AllDesigns/AllDesigns";
import Settings from "./Components/Settings/Settings";
import PageNotFound from "./Components/PageNotFound/PageNotFound";

import { AuthProvider } from "./contexts/authContext.js";

function App() {
  return (
    <div className="App">
      <Router>
        <AuthProvider>
          <Routes>
            <Route
              exact
              path="/"
              element={<PrivateRoute component={HomePage} />}
            />
            <Route
              exact
              path="/profile"
              element={<PrivateRoute component={Profile} />}
            />
            <Route
              exact
              path="/allDesigns"
              element={<PrivateRoute component={AllDesigns} />}
            />
            <Route
              exact
              path="/settings"
              element={<PrivateRoute component={Settings} />}
            />
            <Route
              exact
              path="/design"
              element={<PrivateRoute component={EditingPage} />}
            />
            <Route
              exact
              path="/update-profile"
              element={<PrivateRoute component={UpdateProfile} />}
            />
            <Route exact path="/signup" element={<SignUp />} />
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/forgot-password" element={<ForgotPassword />} />
            <Route exact path="/*" element={<PageNotFound />} />
          </Routes>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
